const SET_ACTIVE_FILTER = 'SET_FILTER_ACTIVE';
const ADD_NEW_FILTER = 'ADD_NEW_FILTER';
const SAVE_FILTER_EDIT = 'SAVE_FILTER_EDIT';
const REMOVE_FILTER = 'REMOVE_FILTER';
const NUKE_FILTERS = 'NUKE_FILTERS';

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  SET_ACTIVE_FILTER,
  ADD_NEW_FILTER,
  SAVE_FILTER_EDIT,
  REMOVE_FILTER,
  NUKE_FILTERS
};
